import DealsEvolved from './DealsEvolved';

export default DealsEvolved;
